"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteContext = void 0;
const react_1 = require("react");
exports.RouteContext = (0, react_1.createContext)({});
